// extracted by mini-css-extract-plugin
export var card = "BlogCard-module--card--2eCgS";
export var cardSmall = "BlogCard-module--card-small--3lvxh BlogCard-module--card--2eCgS";